export const MODEL_SERVICE = {
  name: "",
  price: "",
  regularPrice: "",
  description: "",
  group: "",
};
